export default __webpack_public_path__ + "static/media/sabeel-kms.bb32e0b4.jpg";